import { Color } from "@siteimprove/alfa-css";
import { Style } from "../../style.js";
/**
 * @public
 */
export function hasTextDecoration(device, context) {
    return (element) => {
        const style = Style.from(element, device, context);
        return (style.computed("text-decoration-color").none(Color.isTransparent) &&
            style
                .computed("text-decoration-line")
                .none((line) => line.type === "keyword"));
    };
}
//# sourceMappingURL=has-text-decoration.js.map